import { QueryKey } from "@/query/Query";

export const TemplateTitleMaxLength = 50;
export const TemplateSubjectMaxLength = 255;

export interface TemplateItem {
  id: string;
  title: string;
  content: string;
  subject?: string;
}

export interface TemplateFormValues {
  title: string;
  content: string;
  subject?: string;
}

export interface TemplateApi {
  getAll: () => Promise<TemplateItem[]>;
  create: (values: TemplateFormValues) => Promise<TemplateItem>;
  update: (id: string, values: TemplateFormValues) => Promise<TemplateItem>;
  remove: (id: string) => Promise<void>;
}

export interface TemplateLabels {
  selectTemplate: string;
  addTemplate: string;
  title: string;
  content: string;
  noTemplateSelected: string;
  noTemplates: string;
  saveSuccess: string;
  saveError: string;
  createSuccess: string;
  createError: string;
  deleteSuccess: string;
  deleteError: string;
  deleteConfirmTitle: string;
  deleteConfirmText: string;
}

/** Subject-field settings for template kinds that carry one (e-mail); absence means no subject field. */
export interface TemplateSubjectConfig {
  label: string;
  maxLength: number;
}

export interface TemplateManagementConfig {
  queryKey: QueryKey;
  titleMaxLength: number;
  subject?: TemplateSubjectConfig;
  api: TemplateApi;
  labels: TemplateLabels;
}
